var render = function render(){var _vm=this,_c=_vm._self._c;return _c('languages-list',{attrs:{"title":_vm.field.title,"textStyle":_vm.field.textStyle,"descriptions":_vm.record[_vm.field.name],"fieldName":_vm.field.name,"modal":_vm.modal,"maxLength":_vm.field.length,"field":_vm.field},on:{"update:descriptions":function($event){return _vm.$set(_vm.record, _vm.field.name, $event)},"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }